/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from '@mui/material';
import React, { useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import ExpenseLineItemsPayrollEditableCardComponent from './expenseLineItemsPayrollEditableCard.component';
import ExpenseLineItemsTaxesEditableCard from './expenseLineItemsTaxesEditableCard.component';
import { showToast } from 'modules/layout/layout.actions';

const ExpenseLineItemsTaxesDetailsView = props => {
  const {
    onUpdateCustomTax,
    onDeleteCustomTax,
    onUpdateApprovedLineItemDetails,
    expenseLineItemDetails,
    authId,
    expenseLineId,
    viewOnly,
    enumerations,
    approvedLineItemCustomTaxes,
    onCreateCustomTax,
    isReadOnly
  } = props;

  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isLoadingCustomLineTaxes, setIsLoadingCustomLineTaxes] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const updateApprovedExpense = async values => {
    setIsLoading(false);
    let request = { ...expenseLineItemDetails, ...values };
    const resp = await onUpdateApprovedLineItemDetails(request);
    if (!resp) {
      props.showToast('Failed to update the approved expense account info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      setIsLoading(false);
      return false;
    } else {
      setIsLoading(false);
      return true;
    }
  };

  const handleCreateCustomTax = async values => {
    setIsLoadingCustomLineTaxes(true);
    const resp = await onCreateCustomTax(values);
    if (!resp) {
      props.showToast('Failed to create custom tax', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingCustomLineTaxes(false);
      return false;
    }
    setIsLoadingCustomLineTaxes(false);
    return true;
  };

  const handleUpdateCustomTax = async values => {
    setIsLoadingCustomLineTaxes(true);
    const resp = await onUpdateCustomTax(values);
    if (!resp) {
      props.showToast('Failed to update custom tax', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoadingCustomLineTaxes(false);
      return false;
    }
    setIsLoadingCustomLineTaxes(false);
    return true;
  };

  const handleDeleteCustomTax = async customTaxId => {
    setIsDeleteLoading(true);
    const resp = await onDeleteCustomTax(customTaxId);
    if (!resp) {
      props.showToast('Failed to update custom tax', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsDeleteLoading(false);
      return false;
    }
    setIsDeleteLoading(false);
    return true;
  };

  return (
    <Grid container spacing={2} sx={{ padding: '20px' }}>
      <Grid item sm={12} md={12} lg={7} xl={7} sx={{ display: 'flex', flexDirection: 'column', height: 'auto', alignSelf: 'flex-start' }}>
        <ExpenseLineItemsTaxesEditableCard
          expenseLineItemDetails={expenseLineItemDetails}
          approvedLineItemCustomTaxes={approvedLineItemCustomTaxes}
          updateCustomTaxes={handleUpdateCustomTax}
          deleteCustomTaxes={handleDeleteCustomTax}
          createCustomTaxes={handleCreateCustomTax}
          updateApprovedExpense={updateApprovedExpense}
          isLoading={isLoadingCustomLineTaxes}
          isDeleteLoading={isDeleteLoading}
          enumerations={enumerations}
          expenseLineId={expenseLineId}
          authId={authId}
          viewOnly={viewOnly}
        />
      </Grid>
      <Grid item sm={12} md={12} lg={5} xl={5}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <ExpenseLineItemsPayrollEditableCardComponent
              updateFields={updateApprovedExpense}
              isLoading={isLoading}
              selectedExpenseLineItem={expenseLineItemDetails}
              enumerations={enumerations}
              hideEdit={isReadOnly}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default compose(
  connect(null, {
    showToast
  })
)(ExpenseLineItemsTaxesDetailsView);
